import { Component, inject, input, Signal } from '@angular/core';
import {
  ProductCodes,
  ProductModel,
} from '../../core/models/user-profile.model';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/state/shared/root-state.interface';
import {
  pairProduct,
  switchToProduct,
  unpairProduct,
} from '../../core/state/user-session/user-session.actions';
import { MessageService } from '../../core/services/message.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  imports: [NgClass, MatButton, MatIconButton, MatIcon, TranslateModule],
})
export class ProductCardComponent {
  product: Signal<ProductModel> = input();
  isPaired: Signal<boolean> = input();

  allowList = [ProductCodes.AL, ProductCodes.HE];

  private store = inject(Store<RootState>);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  navigateToProduct() {
    if (this.isPaired()) {
      this.store.dispatch(switchToProduct({ product: this.product() }));
    }
  }

  navigateToLearnMore() {
    window.open(this.product().learnMoreUrl, '_blank');
  }

  unpairProduct(event: MouseEvent) {
    event.stopPropagation();
    this.messageService.showWarning({
      title: this.translateService.instant('home.unpairConfirmationTitle', {
        product: this.product().name,
      }),
      text: this.translateService.instant('home.unpairConfirmationText', {
        product: this.product().name,
        actablUnifiedAccount: this.translateService.instant(
          'actablUnifiedAccount',
        ),
      }),
      buttons: [
        {
          label: this.translateService.instant('cancel'),
          type: 'cancel',
        },
        {
          label: this.translateService.instant('confirm'),
          type: 'confirm',
          actionFn: () =>
            this.store.dispatch(unpairProduct({ product: this.product() })),
        },
      ],
    });
  }

  pairProduct() {
    this.store.dispatch(pairProduct({ productCode: this.product().code }));
  }
}
